module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('module-configuration', {
    attrs: {
      "data": _vm.config,
      "errors": _vm.errors
    }
  }, [_c('div', {
    staticClass: "l-row",
    attrs: {
      "slot": "auth"
    },
    slot: "auth"
  }, [_c('form-group', {
    attrs: {
      "label": "Ambiente",
      "required": true
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.environment),
      expression: "config.auth.environment"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.auth, "environment", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "sandbox"
    }
  }, [_vm._v("Sandbox")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "production"
    }
  }, [_vm._v("Produção")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Token"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.auth.accessToken),
      expression: "config.auth.accessToken"
    }],
    staticClass: "form-input",
    domProps: {
      "value": (_vm.config.auth.accessToken)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.auth, "accessToken", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Produtos"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('product-price-configuration', {
    attrs: {
      "input": _vm.config.product.price
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Redutor de estoque padrão"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.product.stock.reducer),
      expression: "config.product.stock.reducer"
    }],
    staticClass: "form-input",
    attrs: {
      "min": "0",
      "type": "number"
    },
    domProps: {
      "value": (_vm.config.product.stock.reducer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.config.product.stock, "reducer", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Webhook produto aprovado",
      "columns": 6
    }
  }, [_vm._v("\n        " + _vm._s(_vm.urlWebhookProductApproved) + "\n\n        "), _c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.urlWebhookProductApproved),
      expression: "urlWebhookProductApproved",
      arg: "copy"
    }],
    staticClass: "btn btn--sm btn--info copy hint hint--top",
    attrs: {
      "type": "button",
      "data-label": "Clique para copiar"
    }
  }, [_c('i', {
    staticClass: "icon icon-copy2"
  })])])], 1)]), _vm._v(" "), _c('panel', {
    attrs: {
      "title": _vm.$t('expediter.label')
    }
  }, [_c('expediter-configuration', {
    attrs: {
      "expediter": _vm.config.order.expediter
    }
  })], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": _vm.$t('quotation.label')
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-6@md"
  }, [_c('quotation-configuration', {
    attrs: {
      "quotation": _vm.config.quotation,
      "marketplace": _vm.identifier
    }
  })], 1)])]), _vm._v(" "), _c('panel', {
    attrs: {
      "title": _vm.$t('order.label')
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Sincronizar pedidos do tipo Troca"
    }
  }, [_c('label', {
    staticClass: "form-switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.order.syncOrderTypeExchange),
      expression: "config.order.syncOrderTypeExchange"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.config.order.syncOrderTypeExchange) ? _vm._i(_vm.config.order.syncOrderTypeExchange, null) > -1 : (_vm.config.order.syncOrderTypeExchange)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.config.order.syncOrderTypeExchange,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.config.order, "syncOrderTypeExchange", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.config.order, "syncOrderTypeExchange", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.config.order, "syncOrderTypeExchange", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "form-switch__indicator"
  })]), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Define se os pedidos do tipo 'Troca' devem ser sincronizados automaticamente.")])]), _vm._v(" "), _c('order-retrieve-date-configuration', {
    attrs: {
      "orderConfigs": _vm.config.order,
      "columns": 6
    }
  }), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Agrupar produtos com mesmo sku",
      "columns": 3
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.order.groupProducts),
      expression: "config.order.groupProducts"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.order, "groupProducts", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.groupProductsOptions), function(option) {
    return _c('option', {
      key: option,
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(_vm.$t((option + ".label"))))])
  }), 0)])], 1)]), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Sincronização"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Sincronizar estoque",
      "columns": 3
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.synchronize.stock),
      expression: "config.synchronize.stock"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.synchronize, "stock", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.synchronizeOptions), function(option) {
    return _c('option', {
      key: option,
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(_vm.$t((option + ".label"))))])
  }), 0), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Define se os estoques serão sincronizados e atualizados na Netshoes.")])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Sincronizar preço",
      "columns": 3
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.config.synchronize.price),
      expression: "config.synchronize.price"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.config.synchronize, "price", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.synchronizeOptions), function(option) {
    return _c('option', {
      key: option,
      domProps: {
        "value": option
      }
    }, [_vm._v(_vm._s(_vm.$t((option + ".label"))))])
  }), 0), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("Define se os preços serão sincronizados e atualizados na Netshoes.")])])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0bb3e56c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Configuration/Netshoes.vue
// module id = 2893
// module chunks = 0